<template>
    <div class="timer" @click="toggleView">
        <div class="block prefix" v-if="view === 'total'">
            <span class="text">EST :</span>
        </div>
        <div class="block" v-if="days">
            <span class="digit">{{ days }}</span>
            <span class="text">d</span>
        </div>
        <div class="block" v-if="hours">
            <span class="digit">{{ hours }}</span>
            <span class="text">h</span>
        </div>
        <div class="block" v-if="minutes">
            <span class="digit">{{ minutes }}</span>
            <span class="text">m</span>
        </div>
        <div class="block">
            <span class="digit">{{ seconds }}</span>
            <span class="text">s</span>
        </div>
    </div>
</template>

<script>
    export default {

        mounted() {
        },

        props: {
            row: {
                type: Object,
                required: true,
            },
            parentView: {
                type: String,
                required: true,
            },
            now: {
                type: Number
            },
        },

        data: () => ({
            view: 'done',
        }),

        methods: {
            toggleView() {
                this.view = this.view === 'done' ? 'total' : 'done';
            },
        },

        computed: {
            seconds() {
                return Math.trunc(this.viewNumber) % 60;
            },
            minutes() {
                return Math.trunc(this.viewNumber / 60) % 60;
            },
            hours() {
                return Math.trunc(this.viewNumber / 60 / 60) % 24;
            },
            days() {
                return Math.trunc(this.viewNumber / 60 / 60 / 24);
            },
            viewNumber() {
                return this.view === 'done' ? this.secondsElapsed : this.row.est_seconds;
            },
            rowID() {
                return this.row.id;
            },
            secondsElapsed() {
                let seconds = 0;

                for( let user of this.row.users ) {

                    // for each user, add how many seconds are recorded as done
                    if (typeof user.seconds !== 'undefined')
                        seconds += user.seconds;
                    // user.seconds is not set for items, so we should set to the items overall cached seconds (set, not add)
                    else
                        seconds = this.row.seconds;

                    // no need to calc for non-running users
                    if (typeof user.running_since_unix === 'undefined' || user.running_since_unix === null)
                        continue;

                    // item and process view rows that are not batched can simply add the real seconds
                    // also in batched view, seconds should tick normally
                    if (this.parentView === 'batches' || this.row.batch_hash === null) {
                        seconds += this.now - user.running_since_unix;
                        continue;
                    }

                    // apportion the elapsed seconds between the batch's processes, according to their relative size
                    let elapsedSeconds = this.now - user.running_since_unix;
                    let workEstPercentOfBatch = (this.row.est_seconds / this.row.batch_est_seconds) * 100;
                    let relativeSeconds = Math.round((elapsedSeconds / 100) * workEstPercentOfBatch);

                    seconds += relativeSeconds;
                }

                return Math.round(seconds);
            },
        },

        watch: {
            rowID: function() {
                this.view = 'done';
            },
        },

    }
</script>

<style>
    .timer {
        display: inline-block;
        min-width: 50px;
        white-space: nowrap;
        float: right;
        cursor: pointer;
    }
    .timer .prefix .text {
        font-weight: bold;
    }
    .timer .block {
        display: inline-block;
        margin: 3px;
    }
    .timer .digit {
        display: inline-block;
        font-size: 19px;
        color: #3c3c3c;
    }
    .timer .text {
        display: inline-block;
        font-size: 17px;
        color: #6e6e6e;
    }
</style>
